<div class="field list card bg-white-ter no-border pt-0 pb-1 pr-0">
  <div class="control py-1" *ngFor="let choice of choices">
    <label class="checkbox-input mr-4">
      {{ choice.label | stripHtml }}
      <span
        *ngIf="choice.subLabel"
        class="has-tooltip-right has-tooltip-multiline has-tooltip-arrow"
        [attr.data-tooltip]="choice.subLabel | stripHtml"
      >
        <i class="icon icon-Info has-text-grey"></i>
      </span>
      <input
        id="tool-type-{{ choice.value }}-checkbox"
        type="checkbox"
        (click)="toggleFilterOption(choice.value)"
        [checked]="isFilterOptionSelected(choice.value)"
      />
      <span class="checkmark"></span>
    </label>
  </div>
</div>
